__turbopack_context__.v({
  "className": "orbitron_b69e96c7-module__f4sylW__className",
});
